import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import ThemedLogo from 'components/ThemedLogo';

import useHandleTrackEvent from 'hooks/useHandleTrackEvent';

const SidebarNav = () => {
  const handleTrackEvent = useHandleTrackEvent();

  return (
    <Box>
      <Box width={1} paddingX={2} paddingY={1}>
        <ThemedLogo variant="default" width={{ xs: 60, md: 70 }} />
      </Box>
      <Box paddingX={2} paddingY={2}>
        <Box marginTop={2}>
          <Button
            data-trackid={'cta_sign_in_sign_up'}
            size={'large'}
            variant="outlined"
            fullWidth
            component="a"
            href="/auth/signin"
            onClick={(e) => {
              handleTrackEvent(e, 'cta_sign_in_sign_up');
            }}
          >
            Sign In / Sign Up
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

SidebarNav.propTypes = {};

export default SidebarNav;
